<div class="form-style-10">
  <h1 class="header">Application for Admission <br/>
    <span><p>Walden University Office of  Admissions <br/>
            7065 Samuel Morse Dr <br/>
            Columbia, MD 21046</span>
  </h1>
  <form ngNativeValidate #loginForm="ngForm" (ngSubmit)="onSubmit(loginForm)">
    <div class="section">PROGRAM INFORMATION</div>
    <div class="inner-block">
      <div class="inline-div">
        <label class="element">Select a program from the dropdown menu: *
          <select #p (change)="onProgramChange(p.value)" class="element" name="programName"
                  ngModel required>
            <option *ngFor="let p of programData;" [value]="p.id">{{p.name}}</option>
          </select>
        </label>
        <label class="element">Select a UVM Campus from the dropdown menu: *
          <select class="element" name="uvmCampus" ngModel required>
            <option value="1AQ AGUAS CALIENTES">1AQ AGUAS CALIENTES</option>
            <option value="1CC CHAPULTEPEC">1CC CHAPULTEPEC</option>
            <option value="1CH CHIHUAHUA">1CH CHIHUAHUA</option>
            <option value="1CY COYOACAN">1CY COYOACAN</option>
            <option value="1CV CUERNAVACA">1CV CUERNAVACA</option>
            <option value="1CU CUMBRES">1CU CUMBRES</option>
            <option value="1GU GUADALAJARA">1GU GUADALAJARA</option>
            <option value="1HE HERMOSILLO">1HE HERMOSILLO</option>
            <option value="1HP HISPANO">1HP HISPANO</option>
            <option value="1LG LAGO DE GUADALUPE">1LG LAGO DE GUADALUPE</option>
            <option value="1LV LOMAS VERDES">1LV LOMAS VERDES</option>
            <option value="1MR MERIDA">1MR MERIDA</option>
            <option value="1MX MEXICALI">1MX MEXICALI</option>
            <option value="1MO MONTERREY">1MO MONTERREY</option>
            <option value="1NG NOGALES">1NG NOGALES</option>
            <option value="1PU PUEBLA">1PU PUEBLA</option>
            <option value="1QU QUERETARO">1QU QUERETARO</option>
            <option value="1RY REYNOSA">1RY REYNOSA</option>
            <option value="1RO ROMA">1RO ROMA</option>
            <option value="1SA SALTILLO">1SA SALTILLO</option>
            <option value="1SG SAN ANGEL">1SG SAN ANGEL</option>
            <option value="1SL SAN LUIS POTOSI">1SL SAN LUIS POTOSI</option>
            <option value="1SR SAN RAFAEL">1SR SAN RAFAEL</option>
            <option value="1SF SANTA FE">1SF SANTA FE</option>
            <option value="1TM TAMPICO">1TM TAMPICO</option>
            <option value="1TX TEXCOCO">1TX TEXCOCO</option>
            <option value="1TL TLALPAN">1TL TLALPAN</option>
            <option value="1TU TOLUCA">1TU TOLUCA</option>
            <option value="1TO TORREON">1TO TORREON</option>
            <option value="1TA TUXTLA">1TA TUXTLA</option>
            <option value="1VE VERACRUZ">1VE VERACRUZ</option>
            <option value="1VH VILLAHERMOSA">1VH VILLAHERMOSA</option>
            <option value="1GZ ZAPOPAN">1GZ ZAPOPAN</option>
          </select></label>
      </div>
      <div class="inline-div">
        <label class="element">Start Date (MM/DD/YYY) *
          <select class="element" name="programStartDate" id="programStartDate"
                  ngModel required>
            <option value="" selected hidden></option>
            <option *ngFor="let s of startDateData;" [value]="s.id">{{s.date}}</option>
          </select>
        </label>
      </div>
    </div>

    <div class="section" hidden>PARTNER INSTITUTION INFORMATION</div>
    <div class="inner-block" hidden>
      <div class="inline-div">
        <label class="element">Name of College/University:<input type="text" name="collegeName" ngModel/></label>
        <label class="element">Campus:<input type="text" name="campus" ngModel/></label>
        <label class="element">Student ID:<input type="text" name="studentId" ngModel/></label>
      </div>
      <div class="inline-div">
        <label class="element">Program currently enrolled in:<input type="text" name="currentProgram" ngModel/></label>
        <label class="element">Name of Campus Coordinator:<input type="text" name="campusCoordinator" ngModel/></label>
      </div>
    </div>

    <div class="section">APPLICANT INFORMATION</div>
    <div class="inner-block">
      <div class="inline-div">
        <label class="element">First Name: *<input type="text" name="firstName" maxlength="60" ngModel
                                                   required/></label>
        <label class="element">Middle Name: <input type="text" name="middleName" maxlength="60" ngModel/></label>
        <label class="element">Last Name: *<input type="text" name="lastName" maxlength="60" ngModel required/></label>
        <label class="element">Second Last Name: (If applicable)<input type="text" name="secondLastName" maxlength="60"
                                                                       ngModel/></label>
      </div>
      <div class="inline-div">
        <label class="element">Date of birth (DD/MM/YYYY): *<input type="text" name="dateOfBirth" [pattern]="datePattern"
                                                                 ngModel required/></label>
        <label class="element">Social Security No. (###-##-####):<input type="text"
                                                                        [pattern]="ssnPattern" name="ssn"
                                                                        ngModel/></label>
        <label class="element">Laureate ID: *<input type="text" name="laureateID" ngModel required/></label>
      </div>
      <div class="inline-div">
        <label class="element">Address Line 1: *<input type="text" name="addressLine1" ngModel
                                                       style="min-width: 350px"/></label>
        <label class="element">Address Line 2: <input type="text" name="addressLine2" ngModel
                                                      style="min-width: 350px"/></label>
      </div>
      <div class="inline-div">
        <label class="element">City: *<input type="text" name="city" ngModel required/></label>
        <label class="element">Zip/Mailing Code:<input type="text" name="zip" maxlength="5" ngModel/></label>
        <label class="element">Country: *<br>
          <select #t (change)="onCountryChange(t.value)" class="element" name="country"
                  ngModel style="max-width: 250px">
            <option *ngFor="let c of countryData;" [value]="c.id">{{c.country}}</option>
          </select>
        </label>
        <label class="element" *ngIf="itsMexico">State: *
          <select name="state" ngModel required style="min-width:190px">
            <option value="Aguascalientes"> Aguascalientes</option>
            <option value="Baja California"> Baja California</option>
            <option value="Baja California Sur"> Baja California Sur</option>
            <option value="Campeche">Campeche</option>
            <option value="Chiapas">Chiapas</option>
            <option value="Chihuahua">Chihuahua</option>
            <option value="Ciudad de Mexico">Ciudad de Mexico</option>
            <option value="Coahuila ">Coahuila</option>
            <option value="Colima">Colima</option>
            <option value="Durango">Durango</option>
            <option value="Estado de Mexico">Estado de Mexico</option>
            <option value="Guanajuato">Guanajuato</option>
            <option value="Guerrero">Guerrero</option>
            <option value="Hidalgo">Hidalgo</option>
            <option value="Jalisco">Jalisco</option>
            <option value="Michoacan">Michoacan</option>
            <option value="Morelos">Morelos</option>
            <option value="Nayarit">Nayarit</option>
            <option value="Nuevo Leon">Nuevo Leon</option>
            <option value="Oaxaca">Oaxaca</option>
            <option value="Puebla">Puebla</option>
            <option value="Queretaro">Queretaro</option>
            <option value="Quintana Roo">Quintana Roo</option>
            <option value="San Luis Potosi">San Luis Potosi</option>
            <option value="Sinaloa">Sinaloa</option>
            <option value="Sonora">Sonora</option>
            <option value="Tabasco">Tabasco</option>
            <option value="Tamaulipas">Tamaulipas</option>
            <option value="Tlaxcala">Tlaxcala</option>
            <option value="Veracruz">Veracruz</option>
            <option value="Yucatan">Yucatan</option>
            <option value="Zacatecas">Zacatecas</option>
          </select>
        </label>
        <label class="element" *ngIf="!itsMexico">State: *<input type="text" name="state" ngModel required/></label>
      </div>
      <div class="inline-div">
        <label class="element">Home Phone: * (###-###-####)<input type="text" name="homePhone"
                                                                  [pattern]="phoneNumberPattern" ngModel
                                                                  required/></label>
        <label class="element">Work Phone: (###-###-####)<input type="text" name="workPhone"
                                                                [pattern]="phoneNumberPattern"
                                                                ngModel/></label>
        <label class="element">Cell Phone: * (###-###-####)<input type="text" name="cellPhone"
                                                                  [pattern]="phoneNumberPattern" ngModel
                                                                  required/></label>
      </div>
      <div class="inline-div no-bot-margin">
        <div class="element">
          <div class="inner-block">
            <label>Gender: </label>
            <label for="gender1"><input type="radio" name="gender" id="gender1" value="Male" ngModel> Male </label>
            <label for="gender2"><input type="radio" name="gender" id="gender2" value="Female" ngModel> Female</label>
          </div>
        </div>
        <label class="element">Citizenship: *<br>
          <select class="element" name="citizenship" ngModel style="max-width: 250px">
            <option *ngFor="let c of countryData;" [value]="c.id">{{c.country}}</option>
          </select>
        </label>
      </div>
      <div class="inline-div no-bot-margin">
        <label class="element">
          Race/Ethnic Group:
        </label>
      </div>
      <div class="inline-div">
        <div class="element inner-block">
          <label for="race"> <input type="checkbox" value="American Indian/Alaskan Native" id="race" name="race"
                                    ngModel>
            American Indian/Alaskan Native </label>
          <label for="race1"> <input type="checkbox" value="Black (Non-Hispanic)" id="race1" name="race" ngModel>
            Black
            (Non-Hispanic) </label>
          <label for="race2"> <input type="checkbox" value="White (Non-Hispanic)" id="race2" name="race" ngModel>
            White
            (Non-Hispanic) </label>
          <label for="race3"> <input type="checkbox" value="Hispanic/Latino" id="race3" name="race" ngModel>
            Hispanic/Latino </label>
          <label for="race4"> <input type="checkbox" value="Asian/Pacific Islander" id="race4" name="race" ngModel>
            Asian/Pacific Islander </label>
          <label for="race5"> <input type="checkbox" value="Multi-Racial" id="race5" name="race" ngModel> Multi-Racial
          </label>
        </div>
      </div>
    </div>

    <div class="section" hidden>ENGLISH PROFICIENCY INFORMATION</div>
    <div class="inner-wrap align-text-left" hidden>
      <label class="element">Is english your native language?
        <input type="radio" value="Yes" name="englishNativeLanguage" ngModel> Yes
        <input type="radio" value="No" name="englishNativeLanguage" ngModel> No <br> <br>
        <label>If no, please select and provide one of the following to demonstrate English language proficiency.
          English language proficiency scores may not be more than two years old.</label>
        <label>
          <input type="radio" value="TOEFL" name="englishProficiency" ngModel>
          TOEFL: minimum score 550 in the paper based test or 79 in the online test
          version<br>
        </label>
        <label>
          <input type="radio" value="MELAB" name="englishProficiency" ngModel>
          MELAB: A minimum score of 82 <br>
        </label>
        <label>
          <input type="radio" value="IELTS" name="englishProficiency" ngModel>
          IELTS: 6.5 overall band score<br>
        </label>
        <label>
          <input type="radio" value="Pearson Test of English" name="englishProficiency" ngModel>
          Pearson Test of English: A score of 53<br>
        </label>
        <label>
          <input type="radio" value="Laureate English Program" name="englishProficiency" ngModel>
          Laureate English program of Cambridge Touchstone Institutional placement exam at level 5 for Undergraduate/
          level 6 for Graduate<br>
        </label>
        <label>
          <input type="radio" value="Cambridge Touchstone" name="englishProficiency" ngModel>
          Successful completion of Cambridge Touchstone level 4 course<br>
        </label>
        <label>
          <input type="radio" value="Transcript" name="englishProficiency" ngModel>
          Transcript document you have earned a high school diploma or higher from an institution in one of the
          following countries: Australia, Belize, the British Caribbean and British West Indies, Canada (except Quebec),
          England, Guyana, Ireland, Liberia, New Zealand, Scotland, the United States or Wales <br>
        </label>
        <label>
          <input type="radio" value="other" name="englishProficiency" ngModel>
          Other, please specify:
          <input type="text" name="englishProficiencyOther" ngModel>
        </label>
      </label>
    </div>

    <div class="section" hidden>EDUCATIONAL BACKGROUND</div>
    <div class="inner-block" hidden>
      <div class="inline-div">
        <label>Did you graduate from high school or have you earned a General Educational Development
          (GED)?
          <input type="radio" value="Yes" name="highschoolOrGDE" ngModel> Yes
          <input type="radio" value="No" name="highschoolOrGDE" ngModel> No <br>
        </label>
      </div>
      <div class="inline-div">
        <label>If yes, provide the school information:</label>
      </div>
      <div class="inline-div">
        <label class="element">High School Name:
          <input type="text" name="highSchoolName" ngModel/>
        </label>
        <label class="element">Graduation Date (MM/YY):
          <input type="text" name="highSchoolGraduationDate" ngModel/>
        </label>
      </div>
      <div class="inline-div">
        <label class="element">City: <input type="text" name="highSchoolCity" ngModel/></label>
        <label class="element">State: <input type="text" name="highSchoolState" ngModel/></label>
        <label class="element">Country: <input type="text" name="highSchoolCountry" ngModel/></label>
      </div>
    </div>

    <div class="section" hidden>EMPLOYMENT INFORMATION</div>
    <div class="inner-block" hidden>
      <div class="inline-div">
        <label class="element">Are you currently employed? If no, skip this section.
          <input type="radio" value="Yes" name="currentlyEmployed" ngModel> Yes
          <input type="radio" value="No" name="currentlyEmployed" id="currentlyEmployed" ngModel> No <br>
        </label>
      </div>
      <div class="inline-div">
        <label class="element">Employer:
          <input type="text" name="employerName" ngModel/>
        </label>
      </div>
      <div class="inline-div">
        <label class="element">City:
          <input type="text" name="employerCity" ngModel/>
        </label>
        <label class="element">State:
          <input type="text" name="employerState" ngModel/>
        </label>
        <label class="element">Country:
          <input type="text" name="employerCountry" ngModel/>
        </label>
      </div>
      <div class="inline-div">
        <label class="element">Position:
          <input type="text" name="currentPosition" ngModel/>
        </label>
        <label class="element">Employed From (MM/YY):
          <input type="text" name="employedFrom" ngModel/> To (MM/YY): <input type="text" name="employedTo" ngModel/>
        </label>
      </div>
    </div>

    <div class="section">APPLICANT'S EMAIL INFORMATION</div>
    <div class="inner-block">
      <div class="inline-div">
        <label class="element">Your university email address:<input type="email" name="universityEmail"
                                                                    ngModel style="min-width: 350px"/></label>
      </div>
      <div class="inline-div">
        <label class="element">Your personal email address: *<input type="email" name="personalEmail" required
                                                                    ngModel style="min-width: 350px"/></label>
      </div>
    </div>
    <div class="button-section">
      <input class="button" id="submit" type="submit" name="sign-up" prevent-double-submit/>
    </div>
  </form>
</div>
